import { render } from "./clientDrivenIcon.svg?vue&type=template&id=753546ef"
const script = {}
script.render = render

export default script